import { render, staticRenderFns } from "./TenantBuildings.vue?vue&type=template&id=14b30369&scoped=true"
import script from "./TenantBuildings.vue?vue&type=script&lang=js"
export * from "./TenantBuildings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b30369",
  null
  
)

export default component.exports